<template>
  <v-row justify="center" align="center" class="mb-14">
    <v-col cols="12" md="8">
      <v-card>
        <v-card-title class="primary mb-5 white--text">
          Control your packages
          <v-spacer />
          <v-btn
            @click="allowRateUpdate"
            color="default"
            class="float-right"
            :disabled="show"
            x-small
          >
            Edit
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form>
            <v-text-field
              outlined
              type="number"
              :rules="fieldRules"
              v-model="booking_lesson"
              label="Lesson rate"
              prepend-icon="mdi-currency-usd-circle"
              hint="This rate is what students will pay each lesson."
              :disabled="!show"
            />
            <v-text-field
              outlined
              type="number"
              :rules="fieldRules"
              v-model="school_rate"
              label="Driving school rate"
              prepend-icon="mdi-currency-usd-circle"
              hint="This rate applies when student book lesson through a school package"
              :disabled="!show"
            />
            <v-text-field
              outlined
              type="number"
              :rules="fieldRules"
              v-model="roadtest_rent_car"
              label="Road Test car rental rate"
              prepend-icon="mdi-currency-usd-circle"
              :disabled="!show"
              hint="The rate students pay to use their instructor’s car for their driving road test."
            />
            <v-text-field
              outlined
              type="number"
              :rules="fieldRules"
              v-model="rentcar_n_lesson"
              label="Road Test package"
              :disabled="!show"
              prepend-icon="mdi-currency-usd-circle"
              hint="Instructor Car rental + 1 Lesson. This package is for students who want 1 lesson before their driving road test, in addition to using their instructor’s car for the road test."
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="px-5 pb-5">
          <v-spacer />
          <v-btn @click="addPacakage" color="primary" depressed>
            Save changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <v-col cols="12" md="8">
      <v-card>
        <v-card-title class="primary white--text mb-4 justify-space-between">
          Add your bank information
        </v-card-title>
        <v-card-text class="pb-0">
          <p v-if="!payoutSubmitted">
            Adding bank information will allow for payments to be deposited
            directly into your bank account
          </p>
          <p v-else>
            You have already setup your payout information. To update your
            information, click set payout button
          </p>
        </v-card-text>
        <v-card-actions class="px-5 pb-5">
          <v-spacer />
          <v-btn @click="payout" color="primary" depressed>Set Payout</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import Parse from 'parse'
import { mapActions, mapGetters } from 'vuex'
import validationRules from '@/validation-rules'

export default {
  computed: mapGetters(['instructorPackages', 'user', 'userObj']),
  data () {
    return {
      payoutSubmitted: false,
      packageId: null,
      booking_lesson: null,
      school_rate: null,
      roadtest_rent_car: null,
      rentcar_n_lesson: null,
      show: true,
      ...validationRules
    }
  },
  methods: {
    ...mapActions([
      'getInstructorPackages',
      'updatePackage',
      'toggleDialog',
      'updateUser'
    ]),
    async init () {
      await this.getInstructorPackages({ instructorId: this.user.id })
      const packages = this.instructorPackages
      if (packages) {
        this.packageId = packages.id
        this.booking_lesson = packages.get('booking_lesson')
        this.school_rate = packages.get('school_rate')
        this.roadtest_rent_car = packages.get('roadtest_rent_car')
        this.rentcar_n_lesson = packages.get('rentcar_n_lesson')
        this.show = false
      }

      var self = this
      /** incase we still don't have stripe account id */
      if (
        typeof self.user.get('stripeUserAccountId') === 'undefined' ||
        self.user.get('stripeUserAccountId') === ''
      ) {
        var data = {
          email: this.user.get('customEmail')
        }
        /** call the cloud fundtion */
        Parse.Cloud.run('createStripeAccount', data).then(
          function (results) {
            console.log(results.id)
            self.updateUser({
              stripeUserAccountId: results.id
            })
          },
          error => {
            // The object was not retrieved successfully.
            // error is a Parse.Error with an error code and message.
            this.toggleDialog({
              status: true,
              title: 'Error',
              message: error.message
            })
          }
        )
      } else {
        /** Get's get the account details */
        var aData = {
          ownerAccountId: this.user.get('stripeUserAccountId')
        }
        Parse.Cloud.run('getStripeUserAccount', aData).then(
          function (aResult) {
            if (aResult.details_submitted) {
              self.payoutSubmitted = true
            }
          },
          error => {
            console.log(error)
          }
        )
      }
    },
    allowRateUpdate () {
      this.show = true
    },
    async payout () {
      var potData = {
        accountId: this.user.get('stripeUserAccountId'),
        refreshURL: 'https://app.thedriverx.com',
        returnURL: 'https://app.thedriverx.com',
        type: 'account_onboarding'
      }
      const self = this
      await Parse.Cloud.run('getAccountLink', potData).then(
        poResult => {
          console.log(poResult.url)
          self.showPayOut(poResult.url)
        },
        error => {
          this.toggleDialog({
            status: true,
            title: 'Error',
            message: error.message
          })
        }
      )
    },
    showPayOut (url) {
      if (typeof cordova !== 'undefined') {
        var target = '_blank'
        var options =
          'location=no,toolbar=yes,clearsessioncache=yes,clearcache=yes,hideurlbar=yes,closebuttoncaption=Close,hidenavigationbuttons=yes'
        window.cordova.InAppBrowser.open(url, target, options)
        // inAppBrowserRef.addEventListener('loadstart', loadStartCallBack);
        // inAppBrowserRef.addEventListener('loadstop', loadStopCallBack);
        // inAppBrowserRef.addEventListener('exit', this.loadExitCallBack)
        // inAppBrowserRef.addEventListener('message', this.messageCallBack)
      } else {
        window.open(url, '_blank')
      }
    },

    // showPayOut(url) {
    //   console.log(url)
    //   window.open(url)
    // },
    async addPacakage () {
      // const self = this;
      const resposnse = await this.updatePackage({
        instructorId: this.user.id,
        packageId: this.packageId,
        booking_lesson: parseInt(this.booking_lesson),
        school_rate: parseInt(this.school_rate),
        roadtest_rent_car: parseInt(this.roadtest_rent_car),
        rentcar_n_lesson: parseInt(this.rentcar_n_lesson)
      })
      if (resposnse.title === 'Success') {
        this.updateUser({
          packageAdded: true
        })
        // self.getInstructorPackages({
        //   instructorId: self.user.id
        // })
        // const packages = self.instructorPackages
        // packages.then(function(result) {
        //   self.packageId = result.id
        // })
        this.toggleDialog({
          ...resposnse,
          message: 'Package information has been updated.'
        })
        this.show = false
      } else {
        this.toggleDialog(resposnse)
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
